import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {CookiesManager} from '../cookies';
import {StorageHolder} from "../../../../common/core/storage/StorageHolder";
import {RoleService} from "./role.service";

@Injectable()
export class SessionService {

    private static SESSION_LOGOUT: string = 'SESSION_LOGOUT';
    private static SESSION_EXPIRED: string = 'SESSION_EXPIRED';

    constructor(private _router: Router, private roleService: RoleService) {}

    login(session: { token: string, expires: number }) {
        CookiesManager.setToken(session.token, session.expires);

        if (CookiesManager.isDestinationURLExists()) {
            let target: string = CookiesManager.getDestinationURL();
            CookiesManager.clearDestinationURL();
            this._router.navigateByUrl(target);
        } else {
            this._router.navigate(['space']);
        }
    }

    logout() {
        this.closeSession(SessionService.SESSION_LOGOUT);
    }

    expire() {
        this.closeSession(SessionService.SESSION_EXPIRED);
    }

    setSessionCloseAsExpire() {
        if (!this.isSessionClosedBy(SessionService.SESSION_LOGOUT)) {
            this.setSessionCloseAs(SessionService.SESSION_EXPIRED);
        }
    }

    isSessionLogout(): boolean {
        return this.isSessionClosedBy(SessionService.SESSION_LOGOUT);
    }

    isSessionExpired(): boolean {
        return this.isSessionClosedBy(SessionService.SESSION_EXPIRED);
    }

    clearSessionCloseReason(): void {
        this.removeReason(SessionService.SESSION_LOGOUT);
        this.removeReason(SessionService.SESSION_EXPIRED);
    }

    private closeSession(key: string) {
        this.setSessionCloseAs(key);

        CookiesManager.clearToken();
        this.roleService.resetPermissions();
        window.location.reload();
    }

    private setSessionCloseAs(key: string) {
        StorageHolder.localStorage.setItem(key, JSON.stringify(true));
    }

    private isSessionClosedBy(key: string): boolean {
        return JSON.parse(StorageHolder.localStorage.getItem(key));
    }

    private removeReason(key: string): void {
        StorageHolder.localStorage.removeItem(key);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/session.service.ts